<template>
  <Transition name="offline">
    <div v-if="offline" class="ds-offline" role="status" data-testid="offline-banner">{{ t('common.offline') }}</div>
  </Transition>
</template>

<script setup lang="ts">
import { onMounted, onUnmounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';

/** «No connection» strip (02 §2.12). API answers are not cached, so it promises nothing about fresh data. */
const { t } = useI18n();
const offline = ref(typeof navigator !== 'undefined' && navigator.onLine === false);
const set = () => { offline.value = navigator.onLine === false; };
onMounted(() => { window.addEventListener('online', set); window.addEventListener('offline', set); });
onUnmounted(() => { window.removeEventListener('online', set); window.removeEventListener('offline', set); });
</script>

<style scoped lang="scss">
.ds-offline {
  position: fixed;
  left: 50%;
  top: max(10px, var(--app-safe-top));
  transform: translateX(-50%);
  z-index: 1100;
  padding: 8px 14px;
  border-radius: 12px;
  background: var(--toast-bg);
  color: #fff;
  font-size: 12px;
  box-shadow: var(--shadow-modal);
}
.offline-enter-active, .offline-leave-active { transition: opacity var(--dur-med); }
.offline-enter-from, .offline-leave-to { opacity: 0; }
</style>
